import _defineProperty from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate", "type"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { keyframes } from './keyframes.mjs';
import { spring } from './spring.mjs';
import { decay } from './decay.mjs';
import sync, { cancelSync } from 'framesync';
import { interpolate } from '../../utils/interpolate.mjs';
var types = {
  decay: decay,
  keyframes: keyframes,
  spring: spring
};
function loopElapsed(elapsed, duration) {
  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return elapsed - duration - delay;
}
function reverseElapsed(elapsed) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var isForwardPlayback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return isForwardPlayback ? loopElapsed(duration + -elapsed, duration, delay) : duration - (elapsed - duration) + delay;
}
function hasRepeatDelayElapsed(elapsed, duration, delay, isForwardPlayback) {
  return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}
var framesync = function framesync(update) {
  var passTimestamp = function passTimestamp(_ref) {
    var delta = _ref.delta;
    return update(delta);
  };
  return {
    start: function start() {
      return sync.update(passTimestamp, true);
    },
    stop: function stop() {
      return cancelSync.update(passTimestamp);
    }
  };
};
function animate(_ref2) {
  var from = _ref2.from,
    _ref2$autoplay = _ref2.autoplay,
    autoplay = _ref2$autoplay === void 0 ? true : _ref2$autoplay,
    _ref2$driver = _ref2.driver,
    driver = _ref2$driver === void 0 ? framesync : _ref2$driver,
    _ref2$elapsed = _ref2.elapsed,
    elapsed = _ref2$elapsed === void 0 ? 0 : _ref2$elapsed,
    _ref2$repeat = _ref2.repeat,
    repeatMax = _ref2$repeat === void 0 ? 0 : _ref2$repeat,
    _ref2$repeatType = _ref2.repeatType,
    repeatType = _ref2$repeatType === void 0 ? "loop" : _ref2$repeatType,
    _ref2$repeatDelay = _ref2.repeatDelay,
    repeatDelay = _ref2$repeatDelay === void 0 ? 0 : _ref2$repeatDelay,
    onPlay = _ref2.onPlay,
    onStop = _ref2.onStop,
    onComplete = _ref2.onComplete,
    onRepeat = _ref2.onRepeat,
    onUpdate = _ref2.onUpdate,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? "keyframes" : _ref2$type,
    options = _objectWithoutProperties(_ref2, _excluded);
  var _a, _b;
  var to = options.to;
  var driverControls;
  var repeatCount = 0;
  var computedDuration = options.duration;
  var latest;
  var isComplete = false;
  var isForwardPlayback = true;
  var interpolateFromNumber;
  var animator = types[Array.isArray(to) ? "keyframes" : type];
  if ((_b = (_a = animator).needsInterpolation) === null || _b === void 0 ? void 0 : _b.call(_a, from, to)) {
    interpolateFromNumber = interpolate([0, 100], [from, to], {
      clamp: false
    });
    from = 0;
    to = 100;
  }
  var animation = animator(_objectSpread(_objectSpread({}, options), {}, {
    from: from,
    to: to
  }));
  function repeat() {
    repeatCount++;
    if (repeatType === "reverse") {
      isForwardPlayback = repeatCount % 2 === 0;
      elapsed = reverseElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback);
    } else {
      elapsed = loopElapsed(elapsed, computedDuration, repeatDelay);
      if (repeatType === "mirror") animation.flipTarget();
    }
    isComplete = false;
    onRepeat && onRepeat();
  }
  function complete() {
    driverControls.stop();
    onComplete && onComplete();
  }
  function update(delta) {
    if (!isForwardPlayback) delta = -delta;
    elapsed += delta;
    if (!isComplete) {
      var state = animation.next(Math.max(0, elapsed));
      latest = state.value;
      if (interpolateFromNumber) latest = interpolateFromNumber(latest);
      isComplete = isForwardPlayback ? state.done : elapsed <= 0;
    }
    onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(latest);
    if (isComplete) {
      if (repeatCount === 0) computedDuration !== null && computedDuration !== void 0 ? computedDuration : computedDuration = elapsed;
      if (repeatCount < repeatMax) {
        hasRepeatDelayElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
      } else {
        complete();
      }
    }
  }
  function play() {
    onPlay === null || onPlay === void 0 ? void 0 : onPlay();
    driverControls = driver(update);
    driverControls.start();
  }
  autoplay && play();
  return {
    stop: function stop() {
      onStop === null || onStop === void 0 ? void 0 : onStop();
      driverControls.stop();
    }
  };
}
export { animate, hasRepeatDelayElapsed, loopElapsed, reverseElapsed };